import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

import EntityFilters from '../EntityFilters'
import EntityList from '../EntityList'

import Publication from './Publication'

interface PublicationsProps {
  assignLayoutTemplatePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
}

const Publications = (props: PublicationsProps) => {
  const { assignLayoutTemplatePermissionsPayload } = props

  return (
    <DashboardModule title="Publications">
      <Box flexDirection="column" padding="large">
        <EntityFilters assignLayoutTemplatePermissionsPayload={assignLayoutTemplatePermissionsPayload} />

        <EntityList
          assignLayoutTemplatePermissionsPayload={assignLayoutTemplatePermissionsPayload}
          entityKey="publicationIds"
          entityListItemComponent={Publication}
        />
      </Box>
    </DashboardModule>
  )
}

export default Publications
